import src from "IMAGE";
export default { src, width: 2240, height: 2240, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAKklEQVR42q2PMQoAAAgCz/9/uqGGiIKgDhxEBwVHITqfg4pWhTs/G8abBgkwABHLJQgPAAAAAElFTkSuQmCC"};
